import { Checkbox } from '@zoopla-eng/zds/checkbox';
import { Stack } from '@zoopla-eng/zds/stack';
import { checkboxContainerStyle } from './Modal.styles.css';

const features = [
    'has_garden',
    'has_parking_garage',
    'has_balcony_terrace'
] as const;

const featureLabels = {
    has_balcony_terrace: 'Balcony/terrace',
    has_garden: 'Garden',
    has_parking_garage: 'Parking/garage'
};

export type Features = Array<typeof features[number]>;
export type BillsIncluded = '' | 'true';
export type PetsAllowed = '' | 'true';

type MustHavesType = {
    billsIncluded: BillsIncluded;
    petsAllowed: PetsAllowed;
    feature: Features;
};

type MustHavesProps = {
    value: MustHavesType;
    onChange: (mustHaves: MustHavesType) => void;
};

export const MustHaves = ({ value, onChange }: MustHavesProps) => {
    return (
        <Stack
            flexDirection="row"
            flexWrap="wrap"
            // columnGap="0"
            rowGap="S400"
        >
            {[
                ...features.map((feature, index) => {
                    return (
                        <div className={checkboxContainerStyle}>
                            <Checkbox
                                key={`${feature}-${index}`}
                                name={feature}
                                label={featureLabels[feature]}
                                checked={value.feature.includes(feature)}
                                onCheckedChange={(checked) => {
                                    if (checked) {
                                        onChange({
                                            ...value,
                                            feature: [...value.feature, feature]
                                        });
                                    } else {
                                        onChange({
                                            ...value,
                                            feature: value.feature.filter(
                                                (i) => i !== feature
                                            )
                                        });
                                    }
                                }}
                            />
                        </div>
                    );
                }),
                <div className={checkboxContainerStyle}>
                    <Checkbox
                        name="pets_allowed"
                        label="Pets allowed"
                        checked={value.petsAllowed === 'true'}
                        onCheckedChange={(checked) => {
                            onChange({
                                ...value,
                                petsAllowed: checked ? 'true' : ''
                            });
                        }}
                    />
                </div>,
                <div className={checkboxContainerStyle}>
                    <Checkbox
                        name="bills_included"
                        label="Bills included"
                        checked={value.billsIncluded === 'true'}
                        onCheckedChange={(checked) => {
                            onChange({
                                ...value,
                                billsIncluded: checked ? 'true' : ''
                            });
                        }}
                    />
                </div>
            ]}
        </Stack>
    );
};
